<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<p style="margin-top: 180px;">Life is random; change is the only constant, so take it one step at a time and boogie.</p><br/>
<p style="text-align: right;">– Ramón Pérez &amp; Rob Coughler</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?66c20722